import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4.6665 5.3335C4.8597 5.50663 5.03482 5.70051 5.18858 5.91179C5.63951 6.5314 5.90651 7.30043 5.90651 8.1335C5.90651 8.95934 5.6441 9.72225 5.20027 10.3391C5.04372 10.5566 4.86463 10.7559 4.6665 10.9335",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8 14C9.59706 12.7755 10.6667 10.5338 10.6667 7.9711C10.6667 5.44826 9.63003 3.23641 8.07407 2",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1)
  ])))
}
export default { render: render }